<template>
  <div class="w-full h-screen bg-white p-8 overflow-y-auto">
    <div class="max-w-4xl mx-auto">
      <div class="text-center mb-12">
        <h1 class="text-3xl font-bold text-gray-900 mb-4">
          How to Delete Your Data
        </h1>
        <p class="text-lg text-gray-600">
          Follow these steps to delete your Facebook Lens data from the platform
        </p>
      </div>

      <div class="space-y-8">
        <div class="flex items-start space-x-6 p-6 bg-gray-50 rounded-lg">
          <div class="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold">
            1
          </div>
          <div class="flex-1">
            <h3 class="text-xl font-semibold text-gray-900 mb-2">
              Navigate to the Website
            </h3>
            <p class="text-gray-700 mb-3">
              Go to <a
                href="https://almost-there.co/login"
                target="_blank"
                class="font-mono bg-gray-200 px-2 py-1 rounded"
              >https://almost-there.co/login</a> in your web browser
            </p>
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p class="text-sm text-blue-800">
                <strong>Note:</strong> You'll need to use the provided test credentials to log in
              </p>
            </div>
          </div>
        </div>

        <div class="flex items-start space-x-6 p-6 bg-gray-50 rounded-lg">
          <div class="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold">
            2
          </div>
          <div class="flex-1">
            <h3 class="text-xl font-semibold text-gray-900 mb-2">
              Log In with Test Credentials
            </h3>
            <p class="text-gray-700 mb-3">
              Use the provided test credentials to authenticate and access the platform
            </p>
            <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p class="text-sm text-yellow-800">
                <strong>Important:</strong> Make sure you're using the correct test account credentials
              </p>
            </div>
          </div>
        </div>

        <div class="flex items-start space-x-6 p-6 bg-gray-50 rounded-lg">
          <div class="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold">
            3
          </div>
          <div class="flex-1">
            <h3 class="text-xl font-semibold text-gray-900 mb-2">
              Navigate to Facebook Lens Connect Page
            </h3>
            <p class="text-gray-700 mb-3">
              Once logged in, navigate to the route: <span class="font-mono bg-gray-200 px-2 py-1 rounded">/connect-facebook-lens</span>
            </p>
            <div class="bg-gray-100 rounded-lg p-4">
              <p class="text-sm text-gray-700">
                You can type this in your browser's address bar
              </p>
            </div>
          </div>
        </div>

        <div class="flex items-start space-x-6 p-6 bg-gray-50 rounded-lg">
          <div class="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold">
            4
          </div>
          <div class="flex-1">
            <h3 class="text-xl font-semibold text-gray-900 mb-2">
              Click the Delete Data Button
            </h3>
            <p class="text-gray-700 mb-3">
              On the Facebook Lens connect page, locate and click the "Delete all data" button
            </p>
            <div class="bg-red-50 border border-red-200 rounded-lg p-4">
              <p class="text-sm text-red-800">
                <strong>Warning:</strong> This action will permanently delete all your Facebook Lens data and cannot be undone
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-12 p-6 bg-blue-50 border border-blue-200 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-3">
          What Happens After Deletion?
        </h3>
        <ul class="text-blue-800 space-y-2">
          <li class="flex items-start">
            <span class="text-blue-600 mr-2">•</span>
            All data related to your facebook account(s) will be deleted from the platform
          </li>
          <li class="flex items-start">
            <span class="text-blue-600 mr-2">•</span>
            Any saved configurations or settings will be lost
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacebookDeleteDataView',
  metaInfo: {
    title: 'Delete Facebook Lens Data - Instructions'
  }
}
</script>

<style scoped>
/* Additional custom styles if needed */
</style>
